import script from "./AcaraResepsi.vue?vue&type=script&setup=true&lang=js"
export * from "./AcaraResepsi.vue?vue&type=script&setup=true&lang=js"

import "./AcaraResepsi.vue?vue&type=style&index=0&id=f2809196&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2809196"]])

export default __exports__